import React, { useEffect, useRef, useState } from 'react';
import FaIcon from '../../Elements/FaIcon';
import dateTimeHelper from '../../Helpers/datetimeHelper';

// Map a filename extension to a FontAwesome file-type glyph (rendered inside the avatar square).
const fileTypeIcon = (fileName) => {
  const ext = (fileName || '').split('.').pop().toLowerCase();
  if (ext === 'pdf') return 'fa-solid fa-file-pdf';
  if (ext === 'xls' || ext === 'xlsx' || ext === 'csv') return 'fa-solid fa-file-excel';
  if (ext === 'doc' || ext === 'docx') return 'fa-solid fa-file-word';
  if (ext === 'ppt' || ext === 'pptx') return 'fa-solid fa-file-powerpoint';
  if (ext === 'png' || ext === 'jpg' || ext === 'jpeg' || ext === 'gif' || ext === 'bmp') return 'fa-solid fa-file-image';
  if (ext === 'zip' || ext === 'rar' || ext === '7z') return 'fa-solid fa-file-zipper';
  if (ext === 'txt') return 'fa-solid fa-file-lines';
  return 'fa-solid fa-file';
};

function OneFile(props) {
  const [isOpen, setIsOpen] = useState(false);
  const clickTimeout = useRef(null);

  useEffect(() => {
    return () => clearTimeout(clickTimeout.current);
  }, []);

  const onFileClick = () => {
    // Toggle only on a single click. A double click (e.g. to select a word in the description)
    // fires click events too, so defer the toggle briefly and let onFileDoubleClick cancel it.
    // As a safety net, also skip toggling while text is selected.
    clearTimeout(clickTimeout.current);
    clickTimeout.current = setTimeout(() => {
      const selectedText = window.getSelection ? window.getSelection().toString() : '';
      if (selectedText && selectedText.trim().length > 0) {
        return;
      }
      setIsOpen((prev) => !prev);
    }, 250);
  };

  const onFileDoubleClick = () => {
    clearTimeout(clickTimeout.current);
  };

  const file = props.file;

  return (
    <div className={'blist-card' + (file.isDownloaded ? '' : ' unread')}>
      <div className='blist-card-main' onClick={onFileClick} onDoubleClick={onFileDoubleClick}>
        <div className='blist-avatar'>
          <FaIcon iconName={fileTypeIcon(file.fileName)} />
        </div>
        <div className='blist-card-body'>
          <div className='blist-card-head'>
            <span className='blist-card-title dl-name'>{file.fileName}</span>
            <span className='blist-card-date'>{dateTimeHelper.toYYYYsMMsDDsHHsMM(file.createdOn)}</span>
          </div>
          <div className='dl-meta'>
            <span>{Math.ceil(file.fileSize / 1000)} kB</span>
            <span className='dl-dot'>·</span>
            <span>{file.createdByUserName}</span>
            <span className='dl-dot'>·</span>
            <span>Expires {dateTimeHelper.toYYYYsMMsDD(file.expiresOn)}</span>
          </div>
        </div>
        <button
          type='button'
          className='icon-btn dl-download'
          title='Download'
          onClick={(e) => {
            e.stopPropagation();
            props.onDownload(file.fileForDownloadId);
          }}
        >
          <FaIcon iconName='fa-solid fa-download' />
        </button>
        <FaIcon iconName='fa-solid fa-chevron-down' className={'blist-chevron' + (isOpen ? ' open' : '')} />
      </div>
      {isOpen ? (
        <div className='blist-expand'>
          <div className='dl-desc'>{file.description}</div>
          <div className='blist-foot'>
            <div className='blist-foot-meta'>
              <FaIcon iconName='fa-regular fa-user' /> Created by {file.createdByUserName}
              <FaIcon iconName='fa-regular fa-calendar' /> {dateTimeHelper.toYYYYsMMsDDsHHsMM(file.createdOn)}
            </div>
            <div className='blist-foot-actions'>
              <button
                type='button'
                className='btn sm blist-danger'
                onClick={() => props.onDelete(file.fileForDownloadId)}
              >
                <FaIcon iconName='fa-regular fa-trash-can' /> Delete
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default OneFile;
